import { render } from "./NotificationBox.vue?vue&type=template&id=5e6edcd9&scoped=true&lang=pug"
import script from "./NotificationBox.vue?vue&type=script&lang=js"
export * from "./NotificationBox.vue?vue&type=script&lang=js"

import "./NotificationBox.vue?vue&type=style&index=0&id=5e6edcd9&lang=scss&scoped=true"

import exportComponent from "/Users/aladdin/Documents/Petar/fairwey-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e6edcd9"]])

export default __exports__